module.exports = __webpack_public_path__ + "static/media/bg-convite.138730b3.webp";